import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import verifiedIcon from "../../assets/verified.png";
import LoadingOverlay from "../Dashboard/Common/LoadingOverlay";
import AuthStatusPage from "./AuthStatusPage";

const ConfirmEmail = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { confirmationCode } = useParams();
  const [status, setStatus] = useState("");
  const [statusType, setStatusType] = useState("success");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!confirmationCode) {
      setStatus("Verification link is missing or invalid.");
      setStatusType("error");
      setIsLoading(false);
      return;
    }

    let isMounted = true;

    const verifyEmail = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${apiUrl}/auth:confirm_email?confirimation_code=${confirmationCode}`,
        );

        if (!isMounted) {
          return;
        }

        if (response.ok) {
          setStatus("Your email is verified. You can log in now.");
          setStatusType("success");
          window.location.href = "emalpha://open";
        } else {
          setStatus("Verification failed. Please try again.");
          setStatusType("error");
        }
      } catch {
        if (!isMounted) {
          return;
        }
        setStatus("An error occurred. Please try again.");
        setStatusType("error");
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    verifyEmail();

    return () => {
      isMounted = false;
    };
  }, [apiUrl, confirmationCode]);

  const navigateToLogin = () => {
    navigate("/login");
  };

  return (
    isLoading ? (
      <LoadingOverlay />
    ) : (
      <AuthStatusPage
        pageTitle="Email Verification | EMAlpha"
        topBarCtaLabel="Log in"
        topBarCtaTo="/login"
        icon={verifiedIcon}
        iconAlt="Email verified"
        eyebrow={statusType === "success" ? "Verified" : "Verification issue"}
        title={statusType === "success" ? "Email verified" : "Verification failed"}
        description={status}
        tone={statusType}
        primaryAction={{ label: "Back to log in", onClick: navigateToLogin }}
      />
    )
  );
};

export default ConfirmEmail;
